// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/bg-sub.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/bg-sub-mobile.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(var(--grey-100));
  margin: 7.5rem 6.875rem;
  border-radius: 0.75rem;
  overflow: hidden;
}
@media (max-width: 768px) {
  .subscription {
    flex-direction: column-reverse;
    margin: 3.5rem 1rem;
  }
}
.subscription__bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 26rem;
  height: 31.25rem;
}
@media (max-width: 768px) {
  .subscription__bg {
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 8.75rem;
  }
}
.subscription__header {
  color: rgba(var(--grey-800));
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 3.25rem;
}
@media (max-width: 768px) {
  .subscription__header {
    font-size: 1.75rem;
    line-height: 2rem;
  }
}
.subscription__content {
  margin: 0 5.125rem;
}
@media (max-width: 768px) {
  .subscription__content {
    margin: 1.5rem 0 1rem;
    padding: 0 1rem;
  }
}
.subscription__text {
  font-family: var(--merriweather);
  margin-top: 1.5rem;
  margin-bottom: 2rem;
  font-weight: 300;
  font-size: 1rem;
  color: rgba(var(--grey-600));
  line-height: 1.625;
  white-space: pre-line;
}
@media (max-width: 768px) {
  .subscription__text {
    margin-top: 1rem;
    margin-bottom: 1.5rem;
    font-size: 0.875rem;
    line-height: 1.325rem;
  }
}
.subscription__controls {
  display: flex;
  align-items: flex-start;
  margin: 2rem 0 1rem;
}
@media (max-width: 768px) {
  .subscription__controls {
    flex-direction: column;
    margin: 0 0 1rem;
    gap: 1rem;
  }
}
.subscription__controls-email {
  margin-right: 1.5rem;
  width: 17rem;
}
@media (max-width: 768px) {
  .subscription__controls-email {
    margin-right: 0;
    width: 100%;
  }
}
.subscription__confidentiality {
  color: rgba(var(--grey-600));
  font-size: 0.75rem;
}
@media (max-width: 768px) {
  .subscription__confidentiality {
    white-space: pre-line;
  }
}
.subscription__confidentiality-link {
  color: rgba(var(--orange));
}`, "",{"version":3,"sources":["webpack://./src/components/Subscription/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,uCAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AAAF;AAEE;EAVF;IAWI,8BAAA;IACA,mBAAA;EACF;AACF;AACE;EACE,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AACJ;AACI;EAPF;IAQI,WAAA;IACA,yDAAA;IACA,eAAA;EAEJ;AACF;AACE;EACE,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AACJ;AACI;EANF;IAOI,kBAAA;IACA,iBAAA;EAEJ;AACF;AACE;EACE,kBAAA;AACJ;AACI;EAHF;IAII,qBAAA;IACA,eAAA;EAEJ;AACF;AACE;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;AACJ;AACI;EAVF;IAWI,gBAAA;IACA,qBAAA;IACA,mBAAA;IACA,qBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EALF;IAMI,sBAAA;IACA,gBAAA;IACA,SAAA;EAEJ;AACF;AAAI;EACE,oBAAA;EACA,YAAA;AAEN;AAAM;EAJF;IAKI,eAAA;IACA,WAAA;EAGN;AACF;AACE;EACE,4BAAA;EACA,kBAAA;AACJ;AACI;EAJF;IAKI,qBAAA;EAEJ;AACF;AAAI;EACE,0BAAA;AAEN","sourcesContent":[".subscription {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  background-color: rgba(var(--grey-100));\n  margin: 7.5rem 6.875rem;\n  border-radius: 0.75rem;\n  overflow: hidden;\n\n  @media (max-width: 768px) {\n    flex-direction: column-reverse;\n    margin: 3.5rem 1rem;\n  }\n\n  &__bg {\n    background-image: url('../../../public/bg-sub.jpg');\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 26rem;\n    height: 31.25rem;\n\n    @media (max-width: 768px) {\n      width: 100%;\n      background-image: url('../../../public/bg-sub-mobile.jpg');\n      height: 8.75rem;\n    }\n  }\n\n  &__header {\n    color: rgba(var(--grey-800));\n    font-size: 2.5rem;\n    font-weight: 600;\n    line-height: 3.25rem;\n\n    @media (max-width: 768px) {\n      font-size: 1.75rem;\n      line-height: 2rem;\n    }\n  }\n\n  &__content {\n    margin: 0 5.125rem;\n\n    @media (max-width: 768px) {\n      margin: 1.5rem 0 1rem;\n      padding: 0 1rem;\n    }\n  }\n\n  &__text {\n    font-family: var(--merriweather);\n    margin-top: 1.5rem;\n    margin-bottom: 2rem;\n    font-weight: 300;\n    font-size: 1rem;\n    color: rgba(var(--grey-600));\n    line-height: 1.625;\n    white-space: pre-line;\n\n    @media (max-width: 768px) {\n      margin-top: 1rem;\n      margin-bottom: 1.5rem;\n      font-size: 0.875rem;\n      line-height: 1.325rem;\n    }\n  }\n\n  &__controls {\n    display: flex;\n    align-items: flex-start;\n    margin: 2rem 0 1rem;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      margin: 0 0 1rem;\n      gap: 1rem;\n    }\n\n    &-email {\n      margin-right: 1.5rem;\n      width: 17rem;\n\n      @media (max-width: 768px) {\n        margin-right: 0;\n        width: 100%;\n      }\n    }\n  }\n\n  &__confidentiality {\n    color: rgba(var(--grey-600));\n    font-size: 0.75rem;\n\n    @media (max-width: 768px) {\n      white-space: pre-line;\n    }\n\n    &-link {\n      color: rgba(var(--orange));\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
